import { render, staticRenderFns } from "./DetalleForm.vue?vue&type=template&id=f70310f6&"
import script from "./DetalleForm.vue?vue&type=script&lang=ts&"
export * from "./DetalleForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports